import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface ILink {
  text: string,
  url: string
}

@Component({
  selector: 'app-alert-info',
  imports: [TranslateModule],
  templateUrl: './alert-info.component.html',
  styleUrl: './alert-info.component.scss'
})
export class AlertInfoComponent {

  title = input.required<string>();
  subtitle = input.required<string>();
  link = input.required<ILink>();
}
